// extracted by mini-css-extract-plugin
export default {"menuIcon":"SdkApplicationActions_menuIcon__11DFD","menuIconError":"SdkApplicationActions_menuIconError__1x70P"};